import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { estAutorizacionDirecta } from "../../Categorias y Estados/estAutorizacionDirecta";
import { Clientes } from "../../Clientes/Clientes";
import { Personal } from "../../Personal/Personal";
import { Productos } from "../../Productos/Productos";
import { VisitasATiendas } from "../../Rutas/VisitasATiendas/VisitasATiendas";
import { ServiciosConfiguracion } from "../../Servicios/ServiciosConfiguracion/ServiciosConfiguracion";
import { Tiendas } from "../../Tiendas/Tiendas";
import { DatosServiciosAutorizacionProductosAppSupervisorFilters } from "../DatosServiciosAutorizacionProductosAppSupervisorFilters/DatosServiciosAutorizacionProductosAppSupervisorFilters";
import { DatosServiciosAutorizacionProductosFilters } from "../DatosServiciosAutorizacionProductosFilters/DatosServiciosAutorizacionProductosFilters";
import { ACTAutorizarReporte } from "./ACTAutorizarReporte";
import { ACTAutorizarReporteCompleto } from "./ACTAutorizarReporteCompleto";
import { ACTEditarReporte } from "./ACTEditarReporte";
import { ACTRechazarReporte } from "./ACTRechazarReporte";
import { ACTRechazarReporteCompleto } from "./ACTRechazarReporteCompleto";
import { ACTVerDetalles } from "./ACTVerDetalles";
import { AutorizacionGeneralViewColumnsOverrides } from "./AutorizacionGeneralViewColumnsOverrides";

const columns = () =>
(
    {
        c_datos_servicio_id: new EntityColumn<string>({ name: 'c_datos_servicio_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Datos Servicio Id' }),
        c_datos_servicio_registro_id: new EntityColumn<string>({ name: 'c_datos_servicio_registro_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Registro Id' }),
        c_datos_servicio_set_id: new EntityColumn<string>({ name: 'c_datos_servicio_set_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Set Id' }),
        c_visita_id: new EntityColumn<string>({ name: 'c_visita_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Visita Id' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.FK, prompt: 'Servicio Id' }),
        c_paso_id: new EntityColumn<string>({ name: 'c_paso_id', type: 'char', length: 20, flags: c.FK, prompt: 'Paso Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.FK, prompt: 'Tienda Id' }),
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Producto Id' }),
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.FK, prompt: 'Cliente Id' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Id' }),
        c_relevamiento_status_id: new EntityColumn<string>({ name: 'c_relevamiento_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Relevamiento Status Id' }),
        c_autorizacion_directa_status_id: new EntityColumn<string>({ name: 'c_autorizacion_directa_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Autorizacion Directa Status Id' }),
        dt_fecha_hora_realizado: new EntityColumn<Date>({ name: 'dt_fecha_hora_realizado', type: 'datetime', flags: c.Edit, prompt: 'Fecha Hora Realizado' }),
        bt_encabezado: new EntityColumn<boolean>({ name: 'bt_encabezado', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Encabezado' }),
        vc_personal: new EntityColumn<string>({ name: 'vc_personal', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal' }),
        vc_tienda: new EntityColumn<string>({ name: 'vc_tienda', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tienda' }),
        vc_paso: new EntityColumn<string>({ name: 'vc_paso', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Paso' }),
        vc_cliente: new EntityColumn<string>({ name: 'vc_cliente', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cliente' }),
        c_tipo_contenido_id: new EntityColumn<string>({ name: 'c_tipo_contenido_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo Contenido' }),
        vc_contenido: new EntityColumn<string>({ name: 'vc_contenido', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Contenido' }),
        vc_titulo_registro: new EntityColumn<string>({ name: 'vc_titulo_registro', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Título Registro' }),
        c_personal_filtro_id: new EntityColumn<string>({ name: 'c_personal_filtro_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal Filtro Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        dasp_brwStandard: { name: 'dasp_brwStandard', keyMappings: { c_datos_servicio_id: 0 } },
        dasp_brwAutorizacionProductos: { name: 'dasp_brwAutorizacionProductos', keyMappings: { c_datos_servicio_id: 0 } },
        dasp_brwAutorizacionClienteProducto: { name: 'dasp_brwAutorizacionClienteProducto', keyMappings: { c_visita_id: 0, c_cliente_id: 1, c_producto_id: 2 } },
        dasp_brwAutorizacionClienteProductoServicio: { name: 'dasp_brwAutorizacionClienteProductoServicio', keyMappings: { c_datos_servicio_id: 0 } },
        dasp_brwAutorizacionVisitaProductos: { name: 'dasp_brwAutorizacionVisitaProductos', keyMappings: { c_datos_servicio_id: 0 } },
        dasp_brwAutorizacionVisitaServicios: { name: 'dasp_brwAutorizacionVisitaServicios', keyMappings: { c_datos_servicio_id: 0 } },
        dasp_brwAutorizacionGeneral: {
            name: 'dasp_brwAutorizacionGeneral'
            , keyMappings: { c_cliente_id: 12, c_servicio_id: 13, c_producto_id: 14, c_visita_id: 15, c_paso_id: 16, c_datos_servicio_set_id: 17 }
            , gridColumnsOverrides: AutorizacionGeneralViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionProductosFilters(client, parentKeys)
        },
        dasp_brwAutorizacionGeneralAppSupervisor: {
            name: 'dasp_brwAutorizacionGeneralAppSupervisor'
            , keyMappings: { c_cliente_id: 12, c_servicio_id: 13, c_producto_id: 14, c_visita_id: 15, c_paso_id: 16, c_datos_servicio_set_id: 17 }
            , gridColumnsOverrides: AutorizacionGeneralViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionProductosAppSupervisorFilters(client, parentKeys)
        },
        dasp_brwAutorizacionGeneralPorPersonal: {
            name: 'dasp_brwAutorizacionGeneralPorPersonal'
            , keyMappings: { c_cliente_id: 12, c_servicio_id: 13, c_producto_id: 14, c_visita_id: 15, c_paso_id: 16, c_datos_servicio_set_id: 17 }
            , gridColumnsOverrides: AutorizacionGeneralViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionProductosFilters(client, parentKeys)
        }
    }
)

const lookups = () =>
(
    {
        'ServiciosConfiguracion': {
            name: 'ServiciosConfiguracion',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ServiciosConfiguracion(client, parentKeys)
        },

        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Productos(client, parentKeys)
        },

        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },

        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },

        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'VisitasATiendas': {
            name: 'VisitasATiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new VisitasATiendas(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estAutorizacionDirecta(client, parentKeys)
        },
    }
)

const procs = () =>
(
    {
        dasp_AutorizarReporte: { name: 'dasp_AutorizarReporte' },
        dasp_AutorizarReporteCompleto: { name: 'dasp_AutorizarReporteCompleto' },
        dasp_RechazarReporte: { name: 'dasp_RechazarReporte' },
        dasp_RechazarReporteCompleto: { name: 'dasp_RechazarReporteCompleto' },
        dasp_ObtenerDetalles: { name: 'dasp_ObtenerDetalles' }
    }
)

const clientActions = () =>
(
    {
        ACTEditarReporte: ACTEditarReporte,
        ACTVerDetalles: ACTVerDetalles,
        ACTAutorizarReporte: ACTAutorizarReporte,
        ACTAutorizarReporteCompleto: ACTAutorizarReporteCompleto,
        ACTRechazarReporte: ACTRechazarReporte,
        ACTRechazarReporteCompleto: ACTRechazarReporteCompleto
    }
)

export class DatosServiciosAutorizacionProductosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('DatosServiciosAutorizacionProductos');
    }
}